module.exports = __webpack_public_path__ + "img/实验室铅板.b858a7f4.jpg";